import { native, type UserInfo } from '@forest/native-services'
import { createUserInfoSource } from '@forest/paywall-core'
import { shouldMockAPI } from '~/lib/params'

/**
 * The app's single user-info source: loads once from native (mocked under
 * `?mock` in dev, where MSW serves the API anyway), shares the in-flight
 * promise, and lets the paywall-core client refresh the token on 401.
 */
export const userInfoSource = createUserInfoSource({
  load: async () => {
    if (import.meta.env.DEV && shouldMockAPI) {
      return {
        user_type: 'legacy',
        user_id: 1,
        server: 'dev',
        token: 'mock_token',
      } satisfies UserInfo
    }
    const result = await native.user.getUserInfo()
    if (!result.success || !result.data) {
      throw new Error('Failed to get user info')
    }
    return result.data
  },
  refresh: async () => {
    const result = await native.user.refreshToken()
    if (!result.success) throw new Error('Failed to refresh token')
    return result.data
  },
})

export function getUserInfoReady(): Promise<UserInfo> {
  return userInfoSource.getReady()
}
